module.exports = __webpack_public_path__ + "static/media/stomics.98573f8c.png";